import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center position-relative me-1 mr-2" })
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "card-body py-3" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-110px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-110px; text-center" }, "Nama User"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-110px; text-center" }, "Nama File"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-110px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-2" }, "Aksi")
  ])
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-left" }
const _hoisted_16 = { class: "text-left" }
const _hoisted_17 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_18 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "row mt-5 mb-5" }
const _hoisted_27 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_28 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_29 = ["label", "value"]
const _hoisted_30 = { class: "p-3" }
const _hoisted_31 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_32 = { class: "pagination" }
const _hoisted_33 = {
  class: "modal fade",
  ref: "historyDetailModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal_detail_history_upload"
}
const _hoisted_34 = { class: "modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg" }
const _hoisted_35 = { class: "modal-content rounded" }
const _hoisted_36 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_37 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_38 = { class: "svg-icon svg-icon-1" }
const _hoisted_39 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "mb-13 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Informasi Upload Data")
], -1)
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col" }
const _hoisted_43 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_44 = { class: "col" }
const _hoisted_45 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_46 = { class: "col" }
const _hoisted_47 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_48 = {
  key: 0,
  class: "table-responsive mt-4"
}
const _hoisted_49 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Note")
  ])
], -1)
const _hoisted_51 = { class: "text-center" }
const _hoisted_52 = { class: "text-center" }
const _hoisted_53 = { class: "text-center" }
const _hoisted_54 = { class: "modal-footer" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger me-3",
  "data-bs-dismiss": "modal"
}, " Kembali ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Nama File",
                class: "form-control text-center",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileName) = $event)),
                onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
              }, null, 544), [
                [_vModelText, _ctx.fileName]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.status) = $event)),
                placeholder: "Status",
                mode: "single",
                "create-option": false,
                options: _ctx.comboStatus,
                searchable: true,
                label: "name",
                "track-by": "name",
                "value-prop": "_id",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pilihStatusHistory($event)))
              }, null, 8, ["modelValue", "options"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _hoisted_11,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.dateTime2(item.createTime)), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(item.creatorName), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(item.fileName), 1),
                      _createElementVNode("td", _hoisted_16, [
                        (item.status == 'Gagal')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Gagal "))
                          : _createCommentVNode("", true),
                        (item.status == 'Berhasil')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Berhasil "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_19, [
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          "data-bs-toggle": "tooltip modal",
                          title: "Detail",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.modalHistoryDetail(index, item))
                        }, _hoisted_22, 8, _hoisted_20)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_23, _hoisted_25))
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_29))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("ul", _hoisted_32, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("span", _hoisted_38, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("label", _hoisted_43, [
                  _createElementVNode("span", null, "Total Siswa = " + _toDisplayString(_ctx.items.total), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("label", _hoisted_45, [
                  _createElementVNode("span", null, "Data Siswa Valid = " + _toDisplayString(_ctx.items.valid), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("label", _hoisted_47, [
                  _createElementVNode("span", null, "Data Siswa Tidak Valid = " + _toDisplayString(_ctx.items.unValid), 1)
                ])
              ])
            ]),
            (this.items.data.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("table", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.data, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_51, _toDisplayString(item.name), 1),
                          _createElementVNode("td", _hoisted_52, _toDisplayString(item.status), 1),
                          _createElementVNode("td", _hoisted_53, _toDisplayString(item.note), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary me-3",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadHistory()))
            }, " Download "),
            _hoisted_55
          ])
        ])
      ])
    ], 512)
  ], 64))
}